import script from "./FAQPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FAQPage.vue?vue&type=script&setup=true&lang=js"

import "./FAQPage.vue?vue&type=style&index=0&id=31aeafdc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31aeafdc"]])

export default __exports__